import * as React from "react";
import { Avatar } from "react-lorem-ipsum";

export const Header = () => (
  <header>
    <span className="date">Sunday, July 5th</span>
    <h1 className="date-header">Jonathon Doer</h1>
    <div className="avatar">
      <Avatar />
    </div>
  </header>
);
